import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import paths from "routes/paths";

import css from "./type.module.scss";

export const SubscriptionEnterpriseNoAutoRefill = () => {
  return (
    <div className={clsx(css.wrapper, css.yellow)}>
      <div className={css.content}>
        <Link className={css.link} to={paths.settingsBilling()}>
          <strong>
            Enable auto-refill now to ensure you never run out of credits.
          </strong>
        </Link>
      </div>
    </div>
  );
};
